import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ConfirmAlert } from 'modules/common/components/Alert';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function AdditionalItemsModal({
  handleOnParent,
  closeModal,
  dataInfo,
  getActualUseList,
  actualUseList,
  getBuildingComponents,
  componentList,
  getSingleBuildingComponent,
  floorArea,
  ordinanceRevisionId,
  buvAmount,
}) {
  const [formData, setFormData] = useState({
    rptax_actual_use_id: '',
    rptax_building_component_id: '',
    floor: '',
    area: '',
    rate: '',
    is_add_area: '',
  });

  const validateForm = useFormValidator(formData, {
    rptax_actual_use_id: 'required',
    rptax_building_component_id: 'required',
    floor: 'required',
    area: 'required',
    rate: 'required',
  });

  const closeOwnModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding additional item?',
      () => {
        closeModal();
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(dataInfo)) {
      setFormData({
        ...formData,
        id: _.get(dataInfo, 'id'),
        rptax_building_component_id: _.get(
          dataInfo,
          'rptax_building_component_id'
        ),
        rptax_actual_use_id: _.get(dataInfo, 'rptax_actual_use_id'),
        floor: _.get(dataInfo, 'floor'),
        area: _.get(dataInfo, 'area'),
        rate: _.get(dataInfo, 'rate'),
        componentRate: _.get(dataInfo, 'componentRate'),
        type: _.get(dataInfo, 'type'),
        percent: _.get(dataInfo, 'percent'),
        is_add_area: _.get(dataInfo, 'is_add_area'),
      });
    }
  }, []);

  useEffect(() => {
    if (_.get(dataInfo, 'rptax_building_component_id')) {
      getSingleBuildingComponent(
        _.get(dataInfo, 'rptax_building_component_id'),
        (data) => {
          setFormData({
            ...formData,
            percent: _.get(data, 'data.attributes.is_percent'),
            componentRate: _.get(data, 'data.attributes.rate_1'),
            type: _.get(data, 'data.attributes.type'),
          });
        }
      );
    }
  }, [_.get(formData, 'rptax_building_component_id')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      rptax_building_component_id: formData.rptax_building_component_id,
      rptax_actual_use_id: formData.rptax_actual_use_id,
      floor: formData.floor,
      area: formData.area,
      rate: formData.rate,
      componentRate: formData.componentRate,
      type: formData.type,
      percent: formData.percent,
      is_add_area: formData.is_add_area,
    };

    if (!validateForm.response.is_passed) {
      return false;
    }

    handleOnParent(args);
    closeModal();
    return false;
  };

  const handleOnChangeSelect = (key) => (e) => {
    if (key === 'rptax_actual_use_id') {
      setFormData({
        ...formData,
        [key]: e.value,
        rptax_building_component_id: '',
      });
    }
    if (key === 'rptax_building_component_id') {
      getSingleBuildingComponent(e.value, (data) => {
        setFormData({
          ...formData,
          [key]: +_.get(data, 'data.id'),
          percent: _.get(data, 'data.attributes.is_percent'),
          componentRate: _.get(data, 'data.attributes.rate_1'),
          type: _.get(data, 'data.attributes.type'),
        });
      });
    }
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    getActualUseList();
  }, []);

  useEffect(() => {
    getBuildingComponents({ordinance_revision_id: ordinanceRevisionId});
  }, []);

  const actualUseOptions = actualUseList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const componentOptions = componentList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const floorAreaOptions = floorArea.map((x) => {
    return {
      value: x.floor,
      label: x.floor,
    };
  });

  const handleOnChange = (e) => {
    const is_add_area = +_.get(formData, 'is_add_area', 0) ? 0 : 1;

    let newValue = e.target.value;
    if (e.target.name === 'is_add_area') {
      newValue = is_add_area;
    }

    setFormData({
      ...formData,
      [e.target.name]: newValue,
    });
  };

  return (
    <Modal.Body>
      <div>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Floor {validateForm.renderMessage('floor')}
            </label>
            <Select
              value={
                floorAreaOptions.find(
                  (x) => x.value === _.get(formData, 'floor')
                ) || ''
              }
              onChange={handleOnChangeSelect('floor')}
              options={floorAreaOptions}
              placeholder="Select Floor"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Actual Use {validateForm.renderMessage('rptax_actual_use_id')}
            </label>
            <Select
              value={
                actualUseOptions.find(
                  (x) => x.value === _.get(formData, 'rptax_actual_use_id')
                ) || ''
              }
              onChange={handleOnChangeSelect('rptax_actual_use_id')}
              options={actualUseOptions}
              placeholder="Select Actual Use"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Component{' '}
              {validateForm.renderMessage('rptax_building_component_id')}
            </label>
            <Select
              value={
                componentOptions.find(
                  (x) =>
                    x.value === _.get(formData, 'rptax_building_component_id')
                ) || ''
              }
              onChange={handleOnChangeSelect('rptax_building_component_id')}
              options={componentOptions}
              placeholder="Select Building Component"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Area {validateForm.renderMessage('area')}
            </label>
            <NumberFormat
              name="area"
              id="area"
              placeholder="_"
              className="form-control text-uppercase form-input-record"
              onValueChange={(values) => {
                const { floatValue } = values;

                let finalValue = 0;

                if (
                  formData.percent === 1 &&
                  formData.type === 'Adjustment Factor (AF)'
                ) {
                  finalValue = parseFloat(
                    (+formData.componentRate / 100) * floatValue * +buvAmount
                  );
                } else if (
                  formData.percent === 0 &&
                  formData.type === 'Adjustment Factor (AF)'
                ) {
                  finalValue = parseFloat(floatValue * +formData.componentRate);
                } else if (formData.type === 'Adjustment Factor (AF)') {
                  finalValue = parseFloat(floatValue * +buvAmount);
                } else if (formData.type === 'Construction Material (CM)') {
                  finalValue = parseFloat(floatValue * +formData.componentRate);
                } else if (formData.type === 'Additional Item (AI)') {
                  finalValue = parseFloat(
                    (+formData.componentRate / 100) * floatValue * +buvAmount
                  );
                }

                setFormData({
                  ...formData,
                  area: floatValue || 0,
                  rate: finalValue,
                });
              }}
              isNumericString
              thousandSeparator
              displayType="input"
              prefix=""
              value={_.get(formData, 'area', '') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Rate
            </label>
            <input
              readOnly
              className="form-control"
              type="number"
              name="rate"
              value={_.get(formData, 'rate')}
            />
          </div>
          <div className="col-6 form-group">
            <label
              htmlFor="name"
              className="form-label mb-0 pr-5"
              style={{
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#74767b',
              }}
            >
              Add Area to Building Core
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={_.get(formData, 'is_add_area')}
              name="is_add_area"
              id="is_add_area"
              onChange={handleOnChange}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center mt-5">
          <button
            type="button"
            onClick={closeOwnModal}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Back
          </button>
          <button
            type="submit"
            onClick={handleOnSubmit}
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary"
            style={{ color: '#fff' }}
            disabled={!validateForm.response.is_passed}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

AdditionalItemsModal.defaultProps = {
  dataInfo: {},
  floorArea: [],
  buvAmount: 0,
};

AdditionalItemsModal.propTypes = {
  dataInfo: PropTypes.instanceOf(Object),
  handleOnParent: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  componentList: PropTypes.instanceOf(Object).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getSingleBuildingComponent: PropTypes.instanceOf(Function).isRequired,
  getBuildingComponents: PropTypes.instanceOf(Function).isRequired,
  floorArea: PropTypes.instanceOf(Array),
  ordinanceRevisionId: PropTypes.number.isRequired,
  buvAmount: PropTypes.number,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
  componentList: _.get(api, `${c.GET_BUILDING_COMPONENTS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AdditionalItemsModal);
